import { Info } from '@nosinovacao/fe-icons';
import { Button, useI18n } from '@nosinovacao/nosid-mfe-common';
import { useServicesContext } from './context';

export function ServicesNavSheetContent() {
  const { t } = useI18n();
  const { setFlow } = useServicesContext();
  return (
    <div className="flex size-full flex-col gap-8 max-tablet:pb-8">
      <div className="my-auto grid gap-2 break-words pt-20 ">
        <Info width={48} height={48} className="text-nos-blue" />
        <span
          className="font-bold text-nos-neutral-1000 font-title-h3"
          data-tid="title-services-guest"
        >
          {t('Services.Guest.Title')}
        </span>
        <span className="text-nos-neutral-700 font-text-p1" data-tid="text-services-guest-subtitle">
          {t('Services.Guest.Subtitle')}
        </span>
      </div>
      <div className="grid gap-4 tablet:grid-cols-[max-content_max-content] tablet:gap-2">
        <Button
          skin="light"
          className="tablet:order-1"
          variant="secondary"
          type="button"
          data-tid="button-apps"
          onClick={() => setFlow('apps')}
        >
          {t('Services.Guest.Apps')}
        </Button>
        <Button
          skin="light"
          className=""
          type="button"
          data-tid="button-add-services"
          onClick={() => setFlow('add-services')}
        >
          {t('Services.Guest.Button')}
        </Button>
      </div>
    </div>
  );
}
